import SideMenu from './SideMenu';

const DrawerSideMenu = {
  components: { SideMenu },
  props: {
    /**
     * [drawer|sidemenu|null]
     * 为 null 时本组件不展示
     */
    mode: {
      type: [String, null],
      default: 'drawer',
    },
    menus: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    getMobileDrawerSide() {
      const { theme, collapsed, menus } = this;
      const drawerAssign = {
        props: {
          placement: 'left',
          wrapClassName: `drawer-sider ${theme}`,
          closable: false,
          visible: collapsed,
        },
        // @close
        on: this.$listeners,
      };
      const menuAssign = {
        props: {
          mode: 'inline',
          collapsed: false,
          collapsible: true,
          menus,
          theme,
        },
        // @menuSelect
        on: this.$listeners,
      };
      return (
        <a-drawer {...drawerAssign}>
          <SideMenu {...menuAssign} />
        </a-drawer>
      );
    },
    getSideMenu() {
      const { menus, theme, collapsed, title } = this;
      return (
        <side-menu
          mode="inline"
          menus={menus}
          theme={theme}
          collapsed={collapsed}
          collapsible={true}
          title={title}
        ></side-menu>
      );
    },
  },

  render() {
    if (this.mode === 'drawer') {
      return this.getMobileDrawerSide();
    }
    if (this.mode === 'sidemenu') {
      return this.getSideMenu();
    }
    return null;
  },
};

export default DrawerSideMenu;
